import { Group, Loader, Text, useMantineTheme } from "@mantine/core";

const Loading = () => {
  const theme = useMantineTheme();

  return (
    <>
      <Group position="center" mt={40}>
        <Loader size={"xl"} color={theme.colors.gold[0]} />
        <Text>Loading ...</Text>
      </Group>
    </>
  );
};

export default Loading;
